import React from "react";
import Entry from '../../components/Entry';
import EntryConfig from '../../components/entryconfigType';
import '../../Default.css';


export const menuItems: EntryConfig[] = [
  {
    img:"/icons/newspaper-regular.svg",
    img_alt: "description",
    link: "/description",
    text: "opis"
  },
  {
    img:"/icons/circle-exclamation-solid.svg",
    img_alt: "schema",
    link: "/schema",
    text: "schemat"
  },
  {
    img:"/icons/calendar-day-solid.svg",
    img_alt: "essence",
    link: "/essence",
    text: "istota"
  },
  {
    img:"/icons/hand-point-right-solid.svg",
    img_alt: "topic",
    link: "/topic",
    text: "tematy"
  }
]



function Meetings() {
  return (
    <>
      <div className="page-title">
        Spotkania katechetyczne
      </div>
      <div className="navigation-wraper">
        <nav className="navigation-bar">
          {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
        </nav>
      </div>
    </>
  );
}

export default Meetings;
